import { api } from "./api";

export const translateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    translateText: builder.mutation<
      { text: string },
      { text: string; target_language: string }
    >({
      query: ({ text, target_language }) => ({
        url: `/api/translate`,
        method: "POST",
        body: { text, target_language },
      }),
    }),
  }),
});

export const { useTranslateTextMutation } = translateApi;
